import { render } from "./MainHeader.vue?vue&type=template&id=4a479232&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=4a479232&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-4a479232"

export default script